import * as types from "../../actions/types/index";
import { setInitialState } from "../../util/utility";

const INITIAL_STATE = setInitialState({
  payload: null,
  private_broadcast_payload: null,
  availabilityBroadcastSuccess: false,
  availabilityBroadcastError: false,
  availabilityBroadcast: null,
  withdrawAvailabilitySuccess: false,
  withdrawAvailabilityError: false,
  withdrawAvailability: null,
  availabilityRequestsList: null,
  favoriteUser: null,
  favoriteUserSuccess: false,
  favoriteUserError: false,
  unFavoriteUserSuccess: false,
  unFavoriteUserError: false,
  blockUserSuccess: false,
  blockUserError: false,
  unBlockuserSuccess: false,
  unBlockuserError: false,
  removeAvailabilityUserRequestSuccess: false,
  removeAvailabilityUserRequestError: true,
  broadcasterAcceptRequestSuccess: false,
  broadcasterAcceptRequestError: false,
  broadcasterAcceptRequest: null,
  broadcasterTimeoutRequestSuccess: false,
  broadcasterTimeoutRequestError: false,
  broadcasterTimeoutRequest: null,
  showAcceptAvailabilityReqDialog: false,
  acceptAvailabilityData: null,
  notificationData: null,
  notificationDataSuccess: false,
  acceptAvailabilityRequest: false,
  acceptAvailabilityRequestFlag: false,
  acceptAvailabilityRequestMessage:null,
  declineAvailabilityRequest: false,
  declineAvailabilityRequestMessage: null,
  oneToOneAvailabilityList: null,
  groupAvailabilityList: null,
  message:''
});

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.CREATE_AVAILABILITY_REQUEST:
    case types.REQUEST_AVAILABILITY_BROADCAST:
    case types.BROADCASTER_ACCEPT_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case types.CREATE_AVAILABILITY_RECEIVE:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        payload: action.payload.success,
      };
    case types.CREATE_AVAILABILITY_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
        payload: action.payload.response.error,
      };
    // case types.RESET_AVAILABILITY_BROADCAST:
    //     return {
    //         ...state,
    //         payload: action.payload,
    //     };
    case types.REQUEST_AVAILABILITY_BROADCAST_RECEIVE:
      return {
        ...state,
        isFetching: false,
        availabilityBroadcastSuccess: true,
        availabilityBroadcastError: false,
        availabilityBroadcast: action.payload,
      };
    case types.REQUEST_AVAILABILITY_BROADCAST_FAILURE:
      return {
        ...state,
        isFetching: false,
        availabilityBroadcastError: true,
        availabilityBroadcastSuccess: false,
        availabilityBroadcast: action.payload,
      };
    case types.RESET_AVAILABILITY_BROADCAST:
      return {
        ...state,
        availabilityBroadcastError: false,
        availabilityBroadcastSuccess: false,
        availabilityBroadcast: action.payload,
        payload: action.payload,
      };

    case types.WITHDRAW_AVAILABILITY_BROADCAST_RECEIVE:
      return {
        ...state,
        isFetching: false,
        withdrawAvailabilitySuccess: true,
        withdrawAvailabilityError: false,
        withdrawAvailability: action.payload,
      };
    case types.WITHDRAW_AVAILABILITY_BROADCAST_FAILURE:
      return {
        ...state,
        isFetching: false,
        withdrawAvailabilityError: true,
        withdrawAvailabilitySuccess: false,
        withdrawAvailability: action.payload,
      };
    case types.RESET_WITHDRAW_AVAILABILITY_BROADCAST:
      return {
        ...state,
        withdrawAvailabilityError: false,
        withdrawAvailabilitySuccess: false,
        withdrawAvailability: action.payload,
      };

    case types.GET_ALL_REQUEST_AVAILABILITY_BROADCAST_RECEIVE:
      return {
        ...state,
        availabilityRequestsList: action.payload,
        isSuccess: true,
      };
    case types.GET_ALL_REQUEST_AVAILABILITY_BROADCAST_FAILURE:
      return {
        ...state,
        availabilityRequestsList: action.payload,
        isError: true,
      };
    case types.RESET_GET_ALL_REQUEST_AVAILABILITY_BROADCAST:
      return {
        ...state,
        availabilityRequestsList: null,
      };

    case types.FAVORITE_USER_RECEIVE:
      return {
        ...state,
        favoriteUserSuccess: true,
        favoriteUserError: false,
      };
    case types.FAVORITE_BROADCASTER_FAILURE:
      return {
        ...state,
        favoriteUserSuccess: false,
        favoriteUserError: true,
      };
    case types.UNFAVORITE_USER_RECEIVE:
      return {
        ...state,
        unFavoriteUserSuccess: true,
        unFavoriteUserError: false,
      };
    case types.UNFAVORITE_USER_FAILURE:
      return {
        ...state,
        unFavoriteUserSuccess: false,
        unFavoriteUserError: true,
      };
    case types.RESET_FAVORITE_USER:
      return {
        ...state,
        favoriteUserSuccess: false,
        favoriteUserError: false,
        unFavoriteUserSuccess: false,
        unFavoriteUserError: false,
      };

    case types.BLOCK_USER_RECEIVE:
      return {
        ...state,
        blockUserSuccess: true,
        blockUserError: false,
        payload: action.payload.success,
      };
    case types.BLOCK_USER_FAILURE:
      return {
        ...state,
        blockUserSuccess: false,
        blockUserError: true,
        payload: action.payload.response.error,
      };

    case types.UNBLOCK_USER_RECEIVE:
      return {
        ...state,
        unBlockuserError: false,
        unBlockuserSuccess: true,
      };
    case types.UNBLOCK_USER_FAILURE:
      return {
        ...state,
        unBlockuserError: true,
        unBlockuserSuccess: false,
      };
    case types.RESET_BLOCK_USER:
      return {
        ...state,
        blockUserSuccess: false,
        blockUserError: false,
        unBlockuserError: false,
        unBlockuserSuccess: false,
      };

    case types.REMOVE_AVAILABILITY_REQUEST_RECEIVE:
      return {
        ...state,
        removeAvailabilityUserRequestError: false,
        removeAvailabilityUserRequestSuccess: true,
      };
    case types.REMOVE_AVAILABILITY_REQUEST_FAILURE:
      return {
        ...state,
        removeAvailabilityUserRequestError: true,
        removeAvailabilityUserRequestSuccess: false,
      };
    case types.RESET_REMOVE_AVAILABILITY_REQUEST:
      return {
        ...state,
        isFetching: false,
        removeAvailabilityUserRequestError: false,
        removeAvailabilityUserRequestSuccess: false,
      };

    case types.BROADCASTER_ACCEPT_REQUEST_RECEIVE:
      return {
        ...state,
        isFetching: false,
        broadcasterAcceptRequestSuccess: true,
        broadcasterAcceptRequestError: false,
        broadcasterAcceptRequest: action.payload,
      };

    case types.BROADCASTER_ACCEPT_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        broadcasterAcceptRequestError: true,
        broadcasterAcceptRequestSuccess: false,
        broadcasterAcceptRequest: action.payload,
      };
    case types.RESET_BROADCASTER_ACCEPT_REQUEST:
      return {
        ...state,
        broadcasterAcceptRequestSuccess: false,
        broadcasterAcceptRequestError: false,
        broadcasterAcceptRequest: action.payload,
      };
    case types.BROADCASTER_TIMEOUT_REQUEST_RECEIVE:
      return {
        ...state,
        broadcasterTimeoutRequestSuccess: true,
        broadcasterTimeoutRequestError: false,
        broadcasterTimeoutRequest: action.payload,
      };
    case types.BROADCASTER_TIMEOUT_REQUEST_FAILURE:
      return {
        ...state,
        broadcasterTimeoutRequestSuccess: false,
        broadcasterTimeoutRequestError: true,
        broadcasterTimeoutRequest: action.payload,
      };
    case types.RESET_BROADCASTER_TIMEOUT_REQUEST:
      return {
        ...state,
        broadcasterTimeoutRequestSuccess: false,
        broadcasterTimeoutRequestError: false,
        broadcasterTimeoutRequest: action.payload,
      };

    case types.SHOW_ACCEPT_ONE_TO_ONE_AVAILABILITY_REQ_DIALOG:

      return {
        ...state,
        showAcceptAvailabilityReqDialog: true,
        notificationDataSuccess: true,
        acceptAvailabilityData: action.payload,
      };
    case types.HIDE_ACCEPT_ONE_TO_ONE_AVAILABILITY_REQ_DIALOG:
      return {
        ...state,
        showAcceptAvailabilityReqDialog: false,
        notificationDataSuccess: false,
        acceptAvailabilityData: null,
        declineAvailabilityRequestMessage: null,
        acceptAvailabilityRequestMessage:null
      };

    case types.GET_NOTIFICATION_DATA_RECEIVE:

      return {
        ...state,
        notificationDataSuccess: false,
        notificationData: action.payload,
      };
    case types.GET_NOTIFICATION_DATA_FAILURE:
      return {
        ...state,
        notificationDataSuccess: false,
        notificationData: null,
      };
    case types.RESET_NOTIFICATION_DATA:
      return {
        ...state,
        // notificationData: null,
        notificationDataSuccess: false,
      };
    case types.SET_NOTIFICATION_DATA_FROM_NOTIFICATION_PANEL:

      return {
        ...state,
        notificationDataSuccess: false,
        notificationData: action.payload,
      };

    case types.ACCEPT_AVAILABILITY_REQUEST_RECEIVE:
      return {
        ...state,
        acceptAvailabilityRequest: true,
        acceptAvailabilityRequestFlag: true,
        acceptAvailabilityRequestMessage: action.payload
      };
    case types.ACCEPT_AVAILABILITY_REQUEST_FAILURE:
      return {
        ...state,
        acceptAvailabilityRequest: false,
        acceptAvailabilityRequestFlag: false,
        acceptAvailabilityRequestMessage: action.payload
      };
    case types.RESET_ACCEPT_AVAILABILITY_REQUEST:
      return {
        ...state,
        acceptAvailabilityRequest: false,
      };

    case types.RESET_ACCEPT_AVAILABILITY_FLAG:
      return {
        ...state,
        acceptAvailabilityRequestFlag: false,
        acceptAvailabilityRequestMessage: null
      };

    case types.DECLINE_AVAILABILITY_REQUEST_RECEIVE:
      return {
        ...state,
        declineAvailabilityRequest: true,
        declineAvailabilityRequestMessage: action.payload,
      };
    case types.DECLINE_AVAILABILITY_REQUEST_FAILURE:
      return {
        ...state,
        declineAvailabilityRequest: false,
        declineAvailabilityRequestMessage: action.payload,
      };
    case types.RESET_DECLINE_AVAILABILITY_REQUEST:
      return {
        ...state,
        declineAvailabilityRequest: false,
        // declineAvailabilityRequestMessage: null
      };
    case types.ONE_TO_ONE_AVAILABILITY_REQUEST_LIST:
      return {
        ...state,
        oneToOneAvailabilityList: action.payload,
      };
    case types.GROUP_AVAILABILITY_REQUEST_LIST:
      return {
        ...state,
        groupAvailabilityList: action.payload,
      };
    case types.PRIVATE_AVAILABILITY_REQUEST_LIST:
      return {
        ...state,
        privateAvailabilityList: action.payload,
      };
    case types.RESET_AVAILABILITY_REQUEST_LIST:
      return {
        ...state,
        oneToOneAvailabilityList: null,
        groupAvailabilityList: null,
        privateAvailabilityList: null,
      };
    default:
      return {
        ...state,
      };
  }
}
